<template>
    <div class="galerie-images">
        <Button
            class="edit-gallery"
            icon="camera"
            type="white"
            :value="$t('venue_settings.gallery.edit_button')"
            @click="openImageUpload()"
        />
        <Modal v-if="imageUploadOpen" class="modal-images" @cancel="closeImageUpload()">
            <div class="modal-content">
                <div class="title-container">
                    <div class="title copy-l bold">{{ $t('venue_settings.gallery.modal.headline') }}</div>
                    <div class="copy-s">{{ $t('venue_settings.gallery.modal.description') }}</div>
                </div>
                <div class="images-container">
                    <ImageUpload
                        v-for="(src, index) in images"
                        :key="src"
                        minimal
                        :image-src="src"
                        @remove="removeImage(src)"
                        @image="(e) => handleImage(e, index)"
                    />
                    <ImageUpload
                        minimal
                        auto-clear
                        multiple
                        @remove="removeImage(images.length)"
                        @image="(e) => handleImage(e, images.length)"
                    />
                </div>
                <div class="action-container fullwidth">
                    <Button :value="$t('general.cancel')" type="secondary" @click="closeImageUpload()" />
                    <Button :value="$t('general.save')" type="primary" @click="saveImages()" />
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Modal from '@/components/Modal'
import ImageUpload from '@/components/ImageUpload'
import Button from '@/components/Button'

export default {
    name: 'GalleryImages',
    components: {
        Modal,
        ImageUpload,
        Button,
    },
    props: {
        imageUrls: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            imageUploadOpen: false,
            images: [...this.imageUrls],
        }
    },
    watch: {
        imageUrls: function (val) {
            this.images = val
        },
    },
    methods: {
        removeImage(src) {
            let index = this.images.indexOf(src)
            this.images.splice(index, 1)
        },
        openImageUpload() {
            this.imageUploadOpen = true
        },
        closeImageUpload() {
            this.imageUploadOpen = false
            this.images = this.imageUrls
        },
        handleImage(base64Files, index) {
            if (base64Files instanceof Array && base64Files.length > 1) {
                // add a new images to the existing images
                this.images = this.images.concat(base64Files)
            } else {
                let base64File = base64Files
                if (base64Files instanceof Array) {
                    base64File = base64Files[0]
                }
                // add a new image to the existing images
                if (index === this.images.length) {
                    this.images.push(base64File)
                } else {
                    this.images[index] = base64File
                }
            }
        },
        async saveImages() {
            this.$emit('save', this.images)
            this.closeImageUpload()
        },
    },
}
</script>

<style scoped lang="sass">
.galerie-images
    .modal-images
        .modal-content
            width: 684px
            .images-container
                display: grid
                grid-template-columns: 1fr 1fr 1fr
                grid-gap: 18px

                ::v-deep .image-upload
                    min-width: 210px
                    max-width: 230px
                    min-height: 200px
                    max-height: 200px

                    .dropzone-preview
                        padding: 0
                        height: 200px


            .title-container
                display: block
                margin-bottom: $xl

                .copy-s
                    margin-top: $xxs

            .action-container
                margin-top: $xl
</style>
